/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Quickchatorsearch3Inputs */

const zh_learn_quickchatorsearch3 = /** @type {(inputs: Learn_Quickchatorsearch3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快速聊天或搜索`)
};

const en_learn_quickchatorsearch3 = /** @type {(inputs: Learn_Quickchatorsearch3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quick chat or search`)
};

const es_learn_quickchatorsearch3 = /** @type {(inputs: Learn_Quickchatorsearch3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat rápido o búsqueda`)
};

/**
* | output |
* | --- |
* | "Quick chat or search" |
*
* @param {Learn_Quickchatorsearch3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_quickchatorsearch3 = /** @type {((inputs?: Learn_Quickchatorsearch3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Quickchatorsearch3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_quickchatorsearch3(inputs)
	if (locale === "en") return en_learn_quickchatorsearch3(inputs)
	return es_learn_quickchatorsearch3(inputs)
});
export { learn_quickchatorsearch3 as "learn_quickChatOrSearch" }